import React, { useState, useEffect } from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Multiselect from 'multiselect-react-dropdown';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { helper } from "lib/helper";
import NoticeModal from "models/Notice.modal";
import parentsModal from "models/parents.modal";
import Tutorsmodel from "../../models/tutors.modal";


const AddNotifaction = () => {
  const [selecteduser, setselecteduser]= useState();
  const [getselectedtutor, setgetselectedtutor] = useState()
  const [dataList, setDataList] = useState([]);
  const [teacherlist, setteacherlist] = useState();
  const [usertype, setuserType] = useState();

  const navigate = useNavigate();

  const GetAllTutors = async()=>{
    Tutorsmodel.GetAllTutor()
    .then((responce)=>{
      const data = responce?.data?.data
        
  console.log("teacher",data)
      const parent = data.map(parent => `${parent?.user?.first_name} ${parent?.user?.last_name} (${parent?.mobile})`)
      setteacherlist(parent);
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  useEffect(()=>{GetAllTutors();},[])
  useEffect(() => {
    const ParentID = [];
    parentsModal.Parentlist()
      .then((result) => {

        if (result) {
          const NewResult = result?.data
          const ParentID = NewResult.map(parent => `${parent?.user?.first_name} ${parent?.user?.last_name} (${parent?.mobile})`);
          setDataList(ParentID);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");

      });
  }, [])

  const getListData = async () => {

    await parentsModal
      .Parentlist()
      .then((result) => {

        if (result) {
          setDataList(result);

        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");

      });
  };
  const [formData, setFormData] = useState({

    user_type: '',
    notification_type: '',
    title: '',
    description: '',
    // image: '',
  });
  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });

  };
  const handleSubmit = (event) => {
    console.log("notification")
    event.preventDefault();
    const form = new FormData(event.target);

   if (showTextField){
     const date = form.get("sheduledFor")
     
     const cleanedTimestamp = date .split(/[-T:]/).join('');
     form.set("date",cleanedTimestamp)
        }
    
      const submitType = form.get('submitType');
      if (!showTextField) {
       form.append("sheduledFor","fill")
        } 
        if(usertype == "teachers"){
         form.append("users[]",getselectedtutor)
       }
       if(usertype == "parents"){
         form.append("user[]",selecteduser)
       }
   NoticeModal.Addnotice(form)
      .then((response) => {
        console.log("kksdkfs",response)
       helper.sweetalert.toast(response?.data?.message, "success");
        navigate("/admin/notification")
        
     })
      .catch((error) => {
      console.log(error);
        
      });
  };
  const [option, setOption] = useState([]);
 
  const [selectedItems, setSelectedItems] = useState([]);
  const handleSelect = (selectedList) => {
    setSelectedItems(selectedList);
  };
  const [showTextField, setShowTextField] = useState(false);
  const handleClick = () => {
    if(showTextField){
    setShowTextField(false);}
    else setShowTextField(true)
  };
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add New Notification/Notice</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>User Type</Label>
                        <Input
                          id="forType"
                          name="user_type"
                          type="select"
                          aria-multiselectable
                          onChange={(e)=>setuserType(e.target.value)}
                        >
                          <option value="">select option</option>
                          <option value="all_teachers">Teacher (All)</option>
                          <option value="teachers">Teacher (Custom)</option>
                          <option value="all_parents">Parent (All)</option>
                          <option value="parents">Parent (Custom)</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    {usertype === 'teachers' && (
                      <Col md={6}>
                        <Label for="forType">Teacher List </Label>
                        <Multiselect
                        onSelect={setgetselectedtutor} 
                        onRemove={setgetselectedtutor} 
                        className="custom-multiselect"

                        isObject={false}
                        options={teacherlist}
                        showCheckbox/>
                      </Col>
                    )}
                    {usertype === 'parents' && (
                      <Col md={6}>
                        <Label for="forType">Parent List </Label>
                        <Multiselect
                         
                          isObject={false}
                          options={dataList}
                          showCheckbox
                          onSelect={setselecteduser}
                          
                        />
                      </Col>
                    )}

                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Type</Label>
                        <Input
                          
                          name="notification_type"
                          type="select"

                        >
                          <option value="">select option</option>
                          <option value="Notification">Notification</option>
                          <option value="Notice">Notice</option>
                          <option value="Both">Both</option>

                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>

                    <Col md={6}>
                      <FormGroup>
                      <Label for="forType">Title</Label>
                        <Label>
                        </Label>
                        <Input
                          type="text"
                          name='title'
                          placeholder="Enter Title"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                          <Label for="forType">Banner Image</Label>
                        <Input
                          type="file"
                          name='image'
                          placeholder="Enter Title"
                        />
                      </FormGroup>
                    </Col>

                  </Row>
                  <Row>

                    <Col md={12}>
                      <FormGroup>
                          <Label for="forType">Description</Label>
                        <Input
                          type="textarea"
                          name='description'
                          placeholder="Enter Description"
                        />
                      </FormGroup>
                    </Col>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between", marginLeft: '20px'
                      }} className='mb-5'
                    >
                      <Button
                      value="alone" 
                      name="submitType"
                      color="secondary"
                      type='submit'
                      >
                        SendNow
                      </Button>
                      <Button
                       
                        color="primary"
                       
                        style={{ marginLeft: "5%", backgroundColor: "#080278", color: "white", border: "none" }}
                        onClick={handleClick}
                      >
                        {(showTextField == false ) ? <>Schedule</> : "Cancel"}
                      </Button>
                      {showTextField && (
                        <><Input name="sheduledFor" type="datetime-local"
                        variant="outlined"
                        fullWidth
                      />
                      
                        </>
                      )}
                      {/* )} */}
                    </div>
                  </Row>
                 
                  <Button value="All"
                        color="primary"
                        type="submit"
                        style={{float:'right', marginLeft: "5%", backgroundColor: "#080278", color: "white", border: "none" }}
                      name="submitType"
                      >
                        Submit
                      </Button>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddNotifaction;
